import { AddMetadata, BlockKeys } from '../BlockCatalog';
import { BlockParameters, PipelineBlock } from '../PipelineBlock';
import { PipelineStage } from '../Stage';
import CloseToProjectSketchStage, { CloseToProjectSketchStageParameters } from '../stages/filters/CloseToProjectSketchStage';

export interface CloseToProjectSketchBlockParams extends BlockParameters, CloseToProjectSketchStageParameters {}

@AddMetadata({
    type: BlockKeys.CloseToProjSketch,
    name: 'Close to Project',
    description: 'Filter out sensors that are not within a certain distance from the project sketch',
})
class CloseToProjectSketchBlock extends PipelineBlock<CloseToProjectSketchBlockParams> {
    constructor(params: CloseToProjectSketchBlockParams, id?: string) {
        super(params, id);
    }

    protected override defineStages(): PipelineStage<any>[] {
        return [new CloseToProjectSketchStage(this.getParams())];
    }
}

export default CloseToProjectSketchBlock;
